import React                   from 'react';

import InputContainer          from './InputContainer';
import TargetContainer         from './TargetContainer';
import SolutionGrid            from './SolutionGrid';
import ButtonContainer         from './ButtonContainer';
import EggGhost                from './EggGhost';
import LevelButtons            from './LevelButtons';

import SmallProgressBar        from '../../components/progress_bar/Small';
import BigProgressBar          from '../../components/progress_bar/Big';
import Pyrotechnics            from '../../components/Pyrotechnics';
import OptionMenu              from '../../components/OptionMenu';

import tests                   from './tests';

import colors                  from '../../utils/colors';
import { makeStyles }          from '@material-ui/core/styles';
import { useStateWithPromise } from '../../utils';


const wrongAnswer = `הפתרון שגוי`;
const toManyFails = `נכון!`
const tooSlow = `נכון!`
const wrongMehubarim = 'המחוברים אינם נכונים'

const time = 20000

const useStyles = makeStyles(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
    },
    target: {
        fontSize:        30,
        height:          70,
        width:           150,
        borderRadius:    '0.5em',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        border:          '1px solid #DDD',
        marginBottom:    30,
        transition:      'opacity 0.3s'
    },
    button: {
        width:           200,
        height:          50,
        minHeight:       50,
        backgroundColor: colors.blue,
        color:           '#FFF',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        borderRadius:    '1em',
        cursor:          'pointer'
    },
    pyrotechnics: {
        position:        'fixed',
        width:           '100vw',
        height:          '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        transition:      'all 1s',
        zIndex:          2
    }
}))

type RaffleProps = {
    size:           number[];
    wideScreen:     boolean;
    handleNavigate: (val: string) => void;
    reloadRaffle:   () => void;
}


type containerType = {
    size:               number[];
    showOptionMenu:     boolean;
    pyrotechnics_class: string;
  }


  const PyrotechnicsContainer: React.FC<containerType> = React.memo(({size, showOptionMenu, pyrotechnics_class}) => {
    return (
    <div className = { pyrotechnics_class }
    >
      {
        Array(20).fill(0).map((val, ind) => {
          return(
            <div key = { `pyrotechics_numbers${ind}` }>
                <Pyrotechnics
                  size           = { size }
                  showOptionMenu = { showOptionMenu }
                  num            = { Math.round(Math.random() * 6) }
                />
            </div>
          )
        })
      }
  </div>
)})


const Raffle: React.FC<RaffleProps> = ({ size, wideScreen, handleNavigate, reloadRaffle }) => {

  const classes = useStyles();

  const [first, setFirst]                       = React.useState(0)
  const [testsArr, setTestsArr]                 = useStateWithPromise(tests)
  const [ind, setInd]                           = React.useState(Math.round(Math.random() * (testsArr.length - 1)))
  const [test, setTest]                         = React.useState(testsArr[ind])
  const [answer, setAnswer]                     = React.useState(test[0] + test[1])
  const [testedNumber, setTestedNumber]         = React.useState(test[0])
  const [testIndex, setTestIndex]               = React.useState(0)
  const [input1, setInput1]                     = React.useState('')
  const [input2, setInput2]                     = React.useState('')
  const [input3, setInput3]                     = React.useState('')
  const [operator1, setOperator1]               = React.useState('')
  const [operator2, setOperator2]               = React.useState('')
  const [opacity, setOpacity]                   = React.useState(1)
  const [timer, setTimer]                       = React.useState(-1)
  const [expert, setExpert]                     = useStateWithPromise([] as number[]);
  const [selectedInputBox, setSelectedInputBox] = React.useState(0)
  const [success, setSuccess]                   = React.useState(false)
  const [fail, setFail]                         = React.useState(false)
  const [showError, setShowError]               = React.useState(false)
  const [error, setError]                       = React.useState('')
  const [showPyrotechnics, setShowPyrotechnics] = React.useState(false)
  const [showOptionMenu, setShowOptionMenu]     = React.useState(false)
  const [stage1complete, setStage1complete]     = React.useState(false)
  const [failureCounter, setFailureCounter]     = React.useState(0)
  const [closeAtTen, setCloseAtTen]             = React.useState(false)

  const [eggGhost, setEggGhost]                           = React.useState(false)
  const [ghostPosition, setGhostPosition]                 = React.useState([] as number[])
  const [selectedEggsArr, setSelectedEggsArr]             = React.useState([] as number[])
  const [disabledEggsArr, setDisabledEggsArr]             = React.useState([] as number[])
  const [target0Value, setTarget0Value]                   = React.useState(test[0])
  const [target1Value, setTarget1Value]                   = React.useState(test[1])
  const [target0Hover, setTarget0Hover]                   = React.useState(false)
  const [target1Hover, setTarget1Hover]                   = React.useState(false)
  const [selectableEggs, setSelectableEggs]               = React.useState(0)
  const [selectedEggs, setSelectedEggs]                   = React.useState(0)
  const [transferedEggs, setTransferedEggs]               = React.useState(0)
  const [maxSelections, setMaxSelections]                 = React.useState(9)
  const [eggIndex, setEggIndex]                           = React.useState(0)
  const [eggOverflow, setEggOverflow]                     = React.useState(false)
  const [dragOrSelect, setDragOrSelect]                   = React.useState('')
  const [putEggBackInBox, setPutEggBackInBox]             = React.useState(false)
  const [draggedEgg, setDraggedEgg]                       = React.useState(-1)
  const [showFinalValue, setShowFinalValue]               = React.useState(false)
  const [showUndo, setShowUndo]                           = React.useState(true)
  const [eraseImages, setEraseImages]                     = React.useState(false)
  const [showArrangementButton, setShowArrangementButton] = React.useState(false)


  React.useEffect(() => {
    if ((success || failureCounter >= 2) || (showError && error === tooSlow)) {
      setShowArrangementButton(false)
    }
    else if(stage1complete && (target0Value === 10 || target1Value === 10 )) {
       setShowArrangementButton(true)
    }
   },[target0Value, target1Value, stage1complete, success, failureCounter, showError, error])



 React.useEffect(() => {
  if (test[0] > test[1]) {
    setSelectableEggs(1)
  }
  if (test[0] < test[1]) {
    setSelectableEggs(0)
  }
  if (test[0] === test[1]) {
    setSelectableEggs(2)
  }
  setMaxSelections(10 - Math.max(test[0], test[1]))

},[test])
/* 
React.useEffect(() => {
  if (target0Value > target1Value) {
    setSelectableEggs(1)
  }
  if (target0Value < target1Value) {
    setSelectableEggs(0)
  }
  if (target0Value === target1Value) {
    setSelectableEggs(2)
  }
  console.log('10 - Math.max(target0Value, target1Value)     :   ',10 - Math.max(target0Value, target1Value))
  setMaxSelections(10 - Math.max(target0Value, target1Value))

},[target0Value, target1Value])
 */


React.useEffect(() => {
  if (selectableEggs === 2) {
     if (target0Value < target1Value) {
        setSelectableEggs(0)
     }
     if (target1Value < target0Value) {
        setSelectableEggs(1)
     }
  }
},[target0Value, target1Value, selectableEggs])



const wrongAnswerMessage = React.useMemo(() => {

  if ( !stage1complete ) {
    return error
  }

  let msg = error;

  if (
        (
          ( test[0] + test[1] <= 10 ) 
          /* && 
          (( draggedEgg > -1 ) || ( transferedEggs > 0 ))     */
          &&
          (( target0Value > 0 ) && ( target1Value > 0 ))  
        )
        ||
        (
          (test[0] + test[1] > 10)
          &&
          (( target0Value < 10 ) && ( target1Value < 10 ))
        )       
     ) {
      msg = 'העברת הביצים לא הושלמה';
     }

  return msg;

},[ test, /* transferedEggs, draggedEgg,  */target0Value, target1Value, error, stage1complete ])



  const [
    egg_h,
    egg_w,
    target_size,
    T_,
    B_,
    L_0,
    R_0,
    L_1,
    R_1
  ] = React.useMemo(() => {

  const eggH        = 65
  const eggW        = 35

  const targetS     = 300//(size[0] > 950 && size[1] > 700) ? 300 : wideScreen ? 250 : 150;

  const eggTargetT  = size[1]/2 - targetS/4 - eggH/2;
  const eggTargetB  = size[1]/2 + targetS/4 - eggH/2;
  const eggTarget0L = size[0]/2 - targetS - eggW/2;
  const eggTarget0R = size[0]/2 - eggW/2;
  const eggTarget1L = size[0]/2 - eggW/2;
  const eggTarget1R = size[0]/2 + targetS - eggW/2;

  return[
     eggH,
     eggW,
     targetS,
     eggTargetT,
     eggTargetB,
     eggTarget0L,
     eggTarget0R,
     eggTarget1L,
     eggTarget1R,
  ];

},[size/* , wideScreen */])


const arrange = () => {

  setShowUndo(false)
  setShowArrangementButton(false)
  setShowError(false)

  setTimeout(() => {
     setCloseAtTen(true)
     setShowFinalValue(true)
     setSelectedEggsArr([])
     setDisabledEggsArr([])
     setTransferedEggs(0)
  },1000)
  setTimeout(() => {
     setShowUndo(true)
  },2000) 
}

const do_reception = (x: number, y: number) => {

  setGhostPosition([x, y]);
  if ( x > L_0 && x < R_0 && y > T_ && y < B_) {
    setTarget0Hover(true);
  }
  else {
    setTarget0Hover(false);
  }
  if ( x > L_1 && x < R_1 && y > T_ && y < B_) {
    setTarget1Hover(true);
  }
  else {
    setTarget1Hover(false);
  }
}



const handleMouseDown = (e: React.MouseEvent, ind: number) => {

  e.preventDefault();

  if (ind < 0) {

    setShowFinalValue(false)
    setPutEggBackInBox(false)

    if (ind > -200) {
        if (!target0Value || target1Value === 10) {
           return
        }
        setDraggedEgg((ind * -1) - 100)
        setEggIndex(-1)
        setTarget0Hover(true)
    }
    if (ind <= -200) {
        if (!target1Value || target0Value === 10) {
           return
        }
        setDraggedEgg((ind * -1) - 200)
        setEggIndex(-2)
        setTarget1Hover(true)
    }
    setEggGhost(true)
    //setCloseAtTen(true)
    setGhostPosition([e.pageX - egg_w / 2, e.pageY - egg_h / 2]);
  }
}

const handleTouchStart = (e: React.TouchEvent, ind: number) => {

  if (ind < 0) {

   setShowFinalValue(false)
   setPutEggBackInBox(false)

   if (ind > -200) {
      if (!target0Value || target1Value === 10) {
         return
      }
      setEggIndex(-1)
      setTarget0Hover(true)
      //setTarget0Value(target0Value - 1)
   }
   if (ind <= -200) {
      if (!target0Value || target1Value === 10) {
         return
      }
      setEggIndex(-2)
     // setCloseAtTen(true)
      setTarget1Hover(true)
      //setTarget0Value(target1Value - 1)
   }
   setEggGhost(true)
   setGhostPosition([e.touches[0].pageX - egg_w / 2, e.touches[0].pageY - egg_h / 2]);
  }
}

const handleMouseMove = (e: React.MouseEvent) => {
  e.preventDefault();
  if (!eggGhost) {
    return
  }
  if (eggGhost) {
     const x_ = e.pageX - egg_w/2;
     const y_ = e.pageY - egg_h/2;
     do_reception(x_, y_);
  }
}

const handleTouchMove = (e: React.TouchEvent ) => {
  if (!eggGhost) {
    return
  }
  if (eggGhost) {
     const x_ = e.touches[0].pageX - egg_w/2;
     const y_ = e.touches[0].pageY - egg_h/2;
     do_reception(x_, y_);
  }
}

const handleMouseUp = () => {

 if (target0Hover) {
    if (eggGhost) {
      setTarget0Hover(false)
      if (eggIndex === -2) {
         setTarget0Value(target0Value + 1)
         setTarget1Value(target1Value - 1)
         setPutEggBackInBox(false)
         }
      else {
         setPutEggBackInBox(true)
      }
    }
 }
 if (target1Hover) {
    if (eggGhost) {
      setTarget1Hover(false)
      if (eggIndex === -1) {
         setTarget1Value(target1Value + 1)
         setTarget0Value(target0Value - 1)
         setPutEggBackInBox(false)
      }
      else {
         setPutEggBackInBox(true)
      }
    }
 }
 if (eggGhost && !target1Hover && !target0Hover) {
  setPutEggBackInBox(true)
 }
 if (eggGhost) {
    setGhostPosition([0,0]);
    setEggGhost(false)
    setEggIndex(0)
 }
}


const handleEggSelection = (ind: number, counter: number, val: number) => {

  setShowFinalValue(false)

  if (counter === -2) {
    if (selectedEggsArr.includes(val)) {
       const newSelectedEggsArr = selectedEggsArr.slice();
       newSelectedEggsArr.splice(newSelectedEggsArr.indexOf(val), 1);
       setSelectedEggsArr(newSelectedEggsArr)
       setSelectedEggs(newSelectedEggsArr.length)
    }
  }
  if (!eggOverflow && counter === -1) {
     setEggOverflow(true)
     return;
  }
  else {
     if (counter > 0) {
       // setSelectedEggs(counter - transferedEggs)
        if (!selectedEggsArr.includes(val)) {
           const newSelectedEggsArr = selectedEggsArr.slice();
           newSelectedEggsArr.push(val);
           setSelectedEggsArr(newSelectedEggsArr)
           setSelectedEggs(newSelectedEggsArr.length)
        }
     }
  }
  if (selectableEggs === 2) {
     if (ind === -1) {
        setSelectableEggs(0)
     }
     if (ind === -2) {
        setSelectableEggs(1)
     }
  }
}


const transferEggs = () => {
  if (selectableEggs === 0) {
     setTarget0Value(target0Value - selectedEggs)
     setTarget1Value(target1Value + selectedEggs)
  }
  if (selectableEggs === 1) {
     setTarget1Value(target1Value - selectedEggs)
     setTarget0Value(target0Value + selectedEggs)
  }

  setTransferedEggs(selectedEggs)
  setDisabledEggsArr(disabledEggsArr.concat(selectedEggsArr))
  setSelectedEggs(0)
  setSelectedEggsArr([])
 // setCloseAtTen(true)
}


const handleDragButtonClick = () => {
  setDragOrSelect('drag')
  setSelectedEggs(0)
}

const showUndoButton = React.useMemo(() => {
  return (
           showUndo
           &&
           (target0Value > 0 && target0Value !== test[0])
           &&
           (target1Value > 0 && target1Value !== test[1])
         )
},[target0Value, target1Value, test, showUndo])


const unDo = () => {
  setMaxSelections(9)
  setSelectedEggs(0)
  setTransferedEggs(0)
  setTarget0Value(test[0])
  setTarget1Value(test[1])
  setSelectedEggsArr([])
  setDisabledEggsArr([])
  setDraggedEgg(-1)
  setShowFinalValue(true)
  setShowArrangementButton(false)
  setCloseAtTen(false)

}

////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////



  React.useEffect(() => {
   // if (first) {
    if (!first) {
        setFirst(1)
        setTimeout(() => {
            setTimer(0)
        },time)
    }
  },[first])

  React.useEffect(() => {
    if (input1.length && input2.length && input3.length && operator1.length && operator2.length) {
   //   setCloseAtTen(true)
    }
  },[input1, input2, input3, operator1, operator2])


  const showActionButton = React.useMemo(() => {
    const one = input1.length > 0 && input2.length > 0 && operator1.length > 0;
    const two = one && input3.length > 0 && operator2.length > 0;
    return !stage1complete ? one : two
  },[input1, input2, input3, operator1, operator2, stage1complete])


  React.useEffect(() => {
    if (!testsArr.length) {
        setShowPyrotechnics(true)
          setTimeout(() => {
             setShowOptionMenu(true)
        },7000)
    }
  },[testsArr])

  const handleSuccess = async() => {

        const newExpert = expert.slice();

        newExpert.push(testedNumber);
        await setExpert(newExpert)

        const arr = testsArr.slice();

        arr.splice(ind, 1)

        await setTestsArr(arr)

        setSelectedInputBox(0)

        setShowFinalValue(true)
        goToNextTest(arr)

  }


  const goToNextTest = (myArray: number[][]) => {
    if (myArray.length) {
        setOpacity(0)
        setCloseAtTen(false)
        setEraseImages(true)
        setTimeout(() => {
            const rand = Math.round(Math.random() * (myArray.length - 1));
            const nexTest = myArray[rand];
            const newIndex = testIndex + 1;
            setInd(rand)
            setTestIndex(newIndex)
            setTimeout(() => {
                setTimer(newIndex)
            },time)
            setSuccess(false)
            setFail(false)
            setShowError(false)
            setTestedNumber(nexTest[0])
            setTarget0Value(nexTest[0])
            setTarget1Value(nexTest[1])
            setSelectedEggsArr([])
            setDisabledEggsArr([])
            setAnswer(nexTest[0] + nexTest[1])
            setFailureCounter(0)
            setDragOrSelect('')
            setSelectedInputBox(0)
            setSelectableEggs(nexTest[0] > nexTest[1] ? 1 : nexTest[0] < nexTest[1] ? 0 : 2)
            setMaxSelections(9)
            setEggIndex(0)
            setInput1('')
            setInput2('')
            setInput3('')
            setOperator1('')
            setOperator2('')
            setStage1complete(false)
            setPutEggBackInBox(false)
            setEggOverflow(false)
            setDraggedEgg(-1)
            setShowFinalValue(false)
            setSelectedEggs(0)
            setTransferedEggs(0)
            setTest(nexTest)
            setOpacity(1)
            setEraseImages(false)
            setShowArrangementButton(false)
         },300)
     }
     else {
        setShowPyrotechnics(true)
          setTimeout(() => {
             setShowOptionMenu(true)
        },7000)
     }
  }

  const skipTest = () => { 
    goToNextTest(testsArr) 
  }

  const submit = () => {

    if (error === wrongMehubarim) {
      clearInputs();
      return;
    }

    if (!stage1complete) {
      if (showError) {
        setError('')
        setShowError(false)
        return
      }
      if (!input1.length || !input2.length || !operator1.length) {
        setError('חובה למלא את כל השדות')
        setShowError(true)
        return
      }
      if (operator1 !== '+') {
        setError('פעולת החשבון אינה נכונה')
        setShowError(true)
        return
      }
      if (
           (+input1 === test[0] && +input2 === test[1])
           ||
           (+input1 === test[1] && +input2 === test[0])
         ) {
           setStage1complete(true)
           setFailureCounter(0)
           setSelectedInputBox(3)
           return
         }
      else {
        setError(wrongMehubarim)
        setFailureCounter(Math.min(failureCounter + 1, 2))
        setShowError(true)
        return
      }
    }

    if (fail) {
      goToNextTest(testsArr)
      return
    }

    if (showError) {
        setShowError(false)
        setInput3('')
        setOperator2('')
        setSelectedInputBox(3)
        return
    }

    const solutionOnRight = (+input1 === test[0] || +input1 === test[1])
                            &&
                            (+input2 === test[0] || +input2 === test[1])
                            &&
                            (+input3 === test[0] + test[1])
                            &&
                            (operator1 === '+')
                            &&
                            (operator2 === '=')

    const solutionOnLeft = (+input3 === test[0] || +input3 === test[1])
                            &&
                            (+input2 === test[0] || +input2 === test[1])
                            &&
                            (+input1 === test[0] + test[1])
                            &&
                            (operator1 === '=')
                            &&
                            (operator2 === '+')

    const displayAnswer = () => {
        setShowFinalValue(true)
        setSelectedEggsArr([])
        setDisabledEggsArr([])
        setTransferedEggs(0)
        setTarget1Value(answer >= 10 ? answer - 10 : 0)
        setTarget0Value(answer >= 10 ? 10 : answer)
    }


    if (solutionOnRight || solutionOnLeft) {

        displayAnswer();

        if (failureCounter > 1) {
            setError(toManyFails)
            setShowError(true)
            setFail(true)
            return
        }
        else if (timer === testIndex) {
            setError(tooSlow)
            setShowError(true)
            setFail(true)
            return
        }
        else if (!success) {
            setSuccess(true)
        }
        else {
            handleSuccess();
        }
    }
    else {

        if ( answer < 10 && failureCounter >= 1 ) {
          displayAnswer();
        }

        setError(wrongAnswer)
        setFailureCounter(Math.min(failureCounter + 1, 2))
        setShowError(true)
    }
  }

  const handleSolutionClick = (val: string) => {

    const arr = [input1, operator1, input2, operator2, input3]
    const deletePrev = val === 'backspace' && !arr[selectedInputBox].length && selectedInputBox !== 3;
    const newVal = val === 'backspace' ? '' : val

    if (!stage1complete) {
      if (selectedInputBox === 0) { setInput1(newVal) }
      if (selectedInputBox === 1) { deletePrev ? setInput1('')    : setOperator1(newVal) }
      if (selectedInputBox === 2) { deletePrev ? setOperator1('') : setInput2(newVal) }
    }
    if (selectedInputBox === 3) { deletePrev ? setInput2('')    : setOperator2(newVal) }
    if (selectedInputBox === 4) { deletePrev ? setOperator2('') : setInput3(newVal) }

    if (val === 'backspace') {
        if (deletePrev) {
            setSelectedInputBox(Math.max((stage1complete ? 3 : 0), selectedInputBox - 1))
        }
    }
    else {
        setSelectedInputBox(Math.min((stage1complete ? 4 : 2), selectedInputBox + 1))
    }
  }

  const handleInputClick = (val: number) => {
     setError('')
     setShowError(false)
     setSelectedInputBox(val)

  }

  const handleMenuClick = (val: number) => {
    if (val) {
        handleNavigate('menu')
    }
    else {
        reloadRaffle()
    }

  }


  const clearInputs = () => {

    const input1Correct   = +input1 === test[0] || +input1 === test[1];
    const input2Correct   = +input2 === test[0] || +input2 === test[1];
    const operatorCorrect = operator1 === '+';

    setSelectedInputBox(input1Correct ? 1 : 0)
    setInput1(input1Correct ? input1 : '')
    setInput2(input2Correct ? input2 : '')
    setOperator1(operatorCorrect ? operator1 : '')
    setError('')
    setShowError(false)
  }


  return (
     <div
        className     = { classes.root }
        onMouseMove   = { handleMouseMove }
        onTouchMove   = { handleTouchMove }
        onMouseUp     = { handleMouseUp }
        onTouchEnd    = { handleMouseUp }
        onTouchCancel = { handleMouseUp }
     >
        {
            size[0] > 900 && size[1] > 680
            &&
           <BigProgressBar
              size   = { size }
              length = { tests.length }
              prog   = { expert.length }
           />
        }
        {
            (size[0] <= 900 || size[1] <= 680)
            &&
            <SmallProgressBar
              length = { tests.length }
              prog   = { expert.length }
            />
        }
        <ButtonContainer
           size                  = { size }
           wideScreen            = { wideScreen }
           target_size           = { target_size }
           target0Value          = { target0Value }
           target1Value          = { target1Value }
           selectedEggs          = { selectedEggs }
           dragOrSelect          = { dragOrSelect }
           success               = { success }
           stage1complete        = { stage1complete }
           transferEggs          = { transferEggs }
           setDragOrSelect       = { setDragOrSelect }
           handleDragButtonClick = { handleDragButtonClick }
        />
        <TargetContainer
            size                  = { size }
            success               = { success }
            wideScreen            = { wideScreen }
            target_size           = { target_size }
            target0Value          = { target0Value }
            target1Value          = { target1Value }
            selectableEggs        = { selectableEggs }
            selectedEggs          = { selectedEggs }
            transferedEggs        = { transferedEggs }
            maxSelections         = { maxSelections }
            dragOrSelect          = { dragOrSelect }
            correctValues         = { test }
            opacity               = { opacity }
            stage1complete        = { stage1complete }
            draggedEgg            = { draggedEgg }
            showFinalValue        = { showFinalValue }
            putEggBackInBox       = { putEggBackInBox }
            disabledEggsArr       = { disabledEggsArr }
            eraseImages           = { eraseImages }
            closeAtTen            = { closeAtTen }
            failureCounter        = { failureCounter }
            testsArr              = { testsArr }
            showActionButton      = { showActionButton }
            showError             = { showError }
            error                 = { error }
            wrongAnswer           = { wrongAnswer }
            tooSlow               = { tooSlow }
            wrongMehubarim        = { wrongMehubarim }
            showArrangementButton = { showArrangementButton }
            arrange               = { arrange }
            submit                = { submit }   
            handleEggSelection    = { handleEggSelection }
            handleMouseDown       = { handleMouseDown }
            handleTouchStart      = { handleTouchStart }
        />
        <InputContainer
           size                = { size }
           wideScreen          = { wideScreen }
           target_size         = { target_size }
           input1              = { input1 }
           input2              = { input2 }
           input3              = { input3 }
           operator1           = { operator1 }
           operator2           = { operator2 }
           selectedInputBox    = { selectedInputBox }
           stage1complete      = { stage1complete }
           handleInputClick    = { handleInputClick }
           setSelectedInputBox = { setSelectedInputBox }
        />
        <SolutionGrid
           size                  = { size }
           test                  = { test }
           target_size           = { target_size }
           stage1complete        = { stage1complete }
           success               = { success }
           showError             = { showError }
           error                 = { error }
           failureCounter        = { failureCounter }
           answer                = { answer }
           operator2             = { operator2 }
           selectedInputBox      = { selectedInputBox }
           showActionButton      = { showActionButton }
           showArrangementButton = { showArrangementButton }
           wrongAnswerMessage    = { wrongAnswerMessage }
           handleClick           = { handleSolutionClick }
        />
        <LevelButtons
           lastTest           = { testsArr.lenght ? true : false }
           showUndoButton     = { showUndoButton }
           unDo               = { unDo }
           handleGoToNextTest = { skipTest }
        />
        <EggGhost
          eggGhost    = { eggGhost }
          position    = { ghostPosition }
          width       = { egg_w }
          height      = { egg_h }
        />
        {
           showPyrotechnics
           &&
           <PyrotechnicsContainer size = {size} showOptionMenu = {showOptionMenu} pyrotechnics_class = {classes.pyrotechnics} />
        }
        <OptionMenu
           showOptionMenu = { showOptionMenu }
           handleClick    = { handleMenuClick }
        />
     </div>
  );
}



export default Raffle;
